<template>
  <v-app>
    <div id="app">
      <navbar v-if="!isShellRoute" />
      <div
        id="nav"
        :class="{ 'auth-route-shell': isShellRoute }"
      >
        <router-view />
      </div>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/Common/Navbar";

export default {
  components: {
    Navbar,
  },
  computed: {
    isShellRoute() {
      return (
        this.$route &&
        ["/auth", "/trukkin-one"].indexOf(this.$route.path) !== -1
      );
    },
  },
};
</script>
<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "./styles/oms-modern.css";
</style>

<style lang="scss">
@font-face {
  font-family: "Open Sans";
  src: url("assets/OpenSans/OpenSans-Regular.ttf");
  src: url("assets/OpenSans/OpenSans-Bold.ttf");
  src: url("assets/OpenSans/OpenSans-ExtraBold.ttf");
  src: url("assets/OpenSans/OpenSans-Light.ttf");
  src: url("assets/OpenSans/OpenSans-SemiBold.ttf");
}
@font-face {
  font-family: "Montserrat-600";
  src: url("assets/OpenSans/OpenSans-SemiBold.ttf");
}
.Montserrat-600 {
  font-family: Montserrat-600;
}

@font-face {
  font-family: "Montserrat-700";
  src: url("assets/OpenSans/OpenSans-Bold.ttf");
}
.Montserrat-700 {
  font-family: Montserrat-700;
}

#app {
  background: var(--oms-bg, #f6f5f2);
  color: var(--oms-ink, #3a382f);
  font-family:
    Inter,
    "Open Sans",
    "Segoe UI",
    Arial,
    sans-serif;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.muted {
  color: rgba(0, 0, 0, 0.5);
}

.bold {
  font-weight: bold;
  letter-spacing: 0.025rem;
}

.bolder {
  font-weight: 600;
}

.boldest {
  font-weight: 700;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.heading {
  font-size: 1.125rem;
}

.sub-headline {
  font-size: 1.25rem;
}

.nospace {
  margin: 0;
  padding: 0 !important;
}

.nomargin {
  margin: 0;
}

.automargin {
  margin: auto;
}

.nopadding {
  padding: 0 !important;
}

.bg-clr {
  background: var(--oms-surface-soft, #fbfaf7);
}

.heading {
  font-size: 1rem;
}

.text-align-center {
  text-align: center;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.primary-clr {
  color: var(--oms-primary, #ea7a1c);
}

.primary-bg-clr {
  background: var(--oms-primary, #ea7a1c) !important;
  color: white !important;
}
.trukkin-theme.darken-2 {
  background-color: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
}

#nav.auth-route-shell {
  background: #05070e !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  min-height: 100vh;
  min-height: 100svh;
  overflow-x: hidden;
  padding: 0 !important;
}

#nav.auth-route-shell > .auth-page {
  min-height: 100vh;
  min-height: 100svh;
}
</style>
